import { countryCodesMap } from '../shared/data/countryCodesMap';

export const createShallowCopy = (data) => {
    return JSON.parse(JSON.stringify(data));
};

export const generateId = () => Math.random().toString(16).slice(2);

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const getClientFormData = (logos, data) => {
    const fd = new FormData();

    for (let key in logos) {
        if (logos[key].bigLogo.logoData) {
            fd.append(
                `logo_${countryCodesMap[key]}`,
                logos[key].bigLogo.logoData,
            );
        }
        if (logos[key].smallLogo.logoData) {
            fd.append(
                `logo_thumb_${countryCodesMap[key]}`,
                logos[key].smallLogo.logoData,
            );
        }
        if (logos[key].favicon.logoData) {
            fd.append(
                `favicon_${countryCodesMap[key]}`,
                logos[key].favicon.logoData,
            );
        }
        if (logos[key].emailLogo.logoData) {
            fd.append(
                `logo_email_${countryCodesMap[key]}`,
                logos[key].emailLogo.logoData,
            );
        }
    }

    const formDataObject = {};

    Object.entries(data).forEach(([key, value]) => {
        if (key === 'countries_localizations') {
            const countryObject = Object.fromEntries(
                Object.entries(value).map(([countryCode, countryData]) => [
                    countryCode,
                    { ...countryData },
                ]),
            );
            fd.append(key, JSON.stringify(countryObject));
        } else {
            fd.append(key, value);
        }
    });

    fd.forEach((value, key) => {
        formDataObject[key] = value;
    });
    return formDataObject;
};

export const combineClasses = (...args) => {
    const result = [];

    const parseObject = (arg) => {
        let keys = '';

        for (const key in arg) {
            if (arg[key]) keys += ' ' + key;
        }
        return keys.trim();
    };

    for (const className of args.flat(Infinity)) {
        if (className) {
            if (typeof className === 'object') {
                const classes = parseObject(className);
                if (classes) result.push(classes);
                continue;
            }
            result.push(className);
        }
    }

    return result.join(' ');
};

// Get query params from URL
export function getQueryParams() {
    const qp = new URLSearchParams(window.location.search);
    const obj = {};

    qp.forEach((value, key) => {
        if (!isNaN(value) && value.trim() !== '') {
            obj[key] = Number(value);
            return;
        }

        if (value.includes(',')) {
            obj[key] = value.split(',');
            return;
        }

        obj[key] = value;
    });

    return obj;
}

// Set query params in URL without reload
export function setQueryParams(params) {
    const qp = new URLSearchParams();

    Object.keys(params).forEach((key) => {
        const val = params[key];

        if (val === null || val === undefined || val === '') {
            return;
        }

        if (Array.isArray(val)) {
            if (val.length > 0) qp.set(key, val.join(','));
            return;
        }

        qp.set(key, val);
    });

    const sorted = new URLSearchParams(
        [...qp.entries()].sort(([a], [b]) => a.localeCompare(b)),
    );

    const newUrl = `${window.location.pathname}?${sorted.toString()}`;
    window.history.replaceState({}, '', newUrl);
}
